
import React from 'react';
import { BookOpen } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import CourseCatalog from './CourseCatalog';
import { Course, EnrolledCourse } from '@/types';

interface CoursesTabContentProps {
  courses: Course[];
  enrolledCourses: EnrolledCourse[];
  onEnrollCourse: (courseId: string) => void;
  onContinueCourse: (courseId: string, moduleId: string) => void;
}

const CoursesTabContent: React.FC<CoursesTabContentProps> = ({
  courses,
  enrolledCourses,
  onEnrollCourse,
  onContinueCourse
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <BookOpen className="h-5 w-5 text-primary" />
          Course Catalog
        </CardTitle>
        <CardDescription>
          Browse all available courses
        </CardDescription>
      </CardHeader>
      <CardContent>
        <CourseCatalog 
          courses={courses}
          enrolledCourses={enrolledCourses}
          onEnroll={onEnrollCourse}
          onContinueCourse={onContinueCourse}
        />
      </CardContent>
    </Card>
  );
};

export default CoursesTabContent;
